import { createFileRoute } from '@tanstack/react-router';
import { UserFrame } from '@/app/shell/me-layout';
import { NewMinutesSearchSchema } from '@/features/minutes/search';
import { NewMinutesPage } from '@/features/minutes/pages/new-minutes-page';

/**
 * A new PV for a meeting or a calendar event (`?meetingId=` or `?eventId=`, with `spaceId`): the
 * template and the language, then the draft opens. Outside the organisation routes, like the
 * standalone room: the notices and the end of a meeting lead here for everyone who may write it.
 */
export const Route = createFileRoute('/_auth/minutes/new')({
  validateSearch: (search) => NewMinutesSearchSchema.parse(search),
  component: NewMinutesRoute,
});

function NewMinutesRoute() {
  const search = Route.useSearch();
  return (
    <UserFrame>
      <NewMinutesPage search={search} />
    </UserFrame>
  );
}
